import { useMemo } from 'react'

import { useScreen } from '@/store/screen'
import { defaultTheme } from '@/styles/themes'

export const useGlassdoor = () => {
  const { windowSize } = useScreen()

  type FontSizes = {
    [x: string]: keyof typeof defaultTheme.fontSizes
  }

  const fontSizeByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        glassdoorTitle: 'h3' as const,
        glassdoorDescription: 'b3' as const,
        button: 'b1' as const,
        glassdoor: 'h4' as const,
        glassdoorScore: 'h4' as const,
      },
      791: {
        glassdoorTitle: 'b1' as const,
        glassdoorDescription: 'b3' as const,
        button: 'b3' as const,
        glassdoor: 'b2' as const,
        glassdoorScore: 'b4' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo<FontSizes>(() => {
    if (!width) return fontSizeByScreenSize[1440]
    if (width <= 742) return fontSizeByScreenSize[791]

    return fontSizeByScreenSize[1440]
  }, [width, fontSizeByScreenSize])

  const separateStars = (score: number) => {
    const starScoresArray = []
    let starPercentage = score
    for (let i = 1; i <= 5; i += 1)
      if (starPercentage >= 1) {
        starPercentage -= 1
        starScoresArray.push(100)
      } else {
        starScoresArray.push(Number(starPercentage.toFixed(1)) * 100)
        starPercentage = 0
      }
    return starScoresArray
  }

  return {
    fontSizes,
    separateStars,
  }
}
